export default __webpack_public_path__ + "static/seo-appen-f08d08f4ffb0578b7a7706b4761aa5df.png";